/* ============================================================
   MAHER — Store locator (Leaflet map + selectable list)
   ============================================================ */
(function () {
  function init() {
    if (typeof L === 'undefined') { setTimeout(init, 100); return; }

    document.querySelectorAll('[data-locator-stores]').forEach(function (dataEl) {
      var sectionId = dataEl.getAttribute('data-locator-stores');
      var section = document.getElementById('Locator-' + sectionId);
      var mapEl = document.getElementById('storeMap-' + sectionId);
      if (!section || !mapEl) return;

      var stores = [];
      try { stores = JSON.parse(dataEl.textContent); } catch (e) { return; }
      stores = stores.filter(function (s) { return s.lat && s.lng; });
      if (!stores.length) return;

      function markerIcon() {
        return L.divIcon({
          className: '',
          html: '<div class="maher-marker"><svg viewBox="0 0 32 40" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path class="maher-marker__pin" d="M16 0C7.2 0 0 7 0 15.6 0 27 16 40 16 40s16-13 16-24.4C32 7 24.8 0 16 0z"/><circle class="maher-marker__dot" cx="16" cy="15" r="5.5"/></svg></div>',
          iconSize: [32, 40], iconAnchor: [16, 40], popupAnchor: [0, -36]
        });
      }

      var map = L.map(mapEl, { scrollWheelZoom: false, zoomControl: true });
      L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
        subdomains: 'abcd', maxZoom: 19
      }).addTo(map);

      var coords = stores.map(function (s) { return [s.lat, s.lng]; });
      map.fitBounds(L.latLngBounds(coords), { padding: [50, 50] });
      map.once('focus', function () { map.scrollWheelZoom.enable(); });
      map.on('click', function () { map.scrollWheelZoom.enable(); });

      var markers = {};
      var items = {};
      section.querySelectorAll('.store-item').forEach(function (btn) {
        items[btn.dataset.storeId] = btn;
        btn.addEventListener('click', function () { select(btn.dataset.storeId, true); });
      });

      stores.forEach(function (s) {
        var m = L.marker([s.lat, s.lng], { icon: markerIcon(), title: s.name })
          .addTo(map)
          .bindPopup('<strong>' + s.name + '</strong>' + s.address + '<br><a href="' + s.phoneHref + '">' + s.phone + '</a>');
        m.on('click', function () { select(s.id, false); });
        markers[s.id] = m;
      });

      function select(id, pan) {
        Object.keys(items).forEach(function (k) {
          items[k].classList.toggle('is-active', k === id);
          items[k].setAttribute('aria-pressed', String(k === id));
        });
        Object.keys(markers).forEach(function (k) {
          var el = markers[k].getElement && markers[k].getElement();
          if (el) { var inner = el.querySelector('.maher-marker'); if (inner) inner.classList.toggle('is-active', k === id); }
        });
        var s = stores.filter(function (x) { return x.id === id; })[0];
        if (!s) return;
        if (pan) {
          map.flyTo([s.lat, s.lng], 14, { duration: 0.8 });
          setTimeout(function () { markers[id].openPopup(); }, 850);
        } else {
          markers[id].openPopup();
        }
      }

      setTimeout(function () { markers[stores[0].id].openPopup(); }, 400);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
